import hero1 from "../images/Aragon-Killakee_DSC9413_Panorama.jpg";
import hero2 from "../images/130-Sandyford-Road_DSC1692-1.jpg";

import dundrum1 from "../images/Dundrum House/130-Sandyford-Road_DSC1692-1.jpg";
import dundrum2 from "../images/Dundrum House/130-Sandyford-Road_DSC1374_Panorama-5.jpg";
import dundrum3 from "../images/Dundrum House/130-Sandyford-Road_DSC1449_Panorama-4.jpg";
import dundrum4 from "../images/Dundrum House/130-Sandyford-Road_DSC1595-6.jpg";
import dundrum5 from "../images/Dundrum House/130-Sandyford-Road_DSC1600-3.jpg";
import dundrum6 from "../images/Dundrum House/130-Sandyford-Road_DSC1635-7.jpg";
import dundrum7 from "../images/Dundrum House/130-Sandyford-Road_DSC1745-2.jpg";
import dundrum8 from "../images/Dundrum House/130-Sandyford-Road_DSC9358-9.jpg";

import killakee1 from "../images/Killakee House/Aragon-Killakee_DSC9413_Panorama-1-new2.jpg";
import killakee2 from "../images/Killakee House/Aragon-Killakee_DSC9431_Panorama-3-new2.jpg";
import killakee3 from "../images/Killakee House/Aragon-Killakee_DSC9442-4 new2.jpg";
import killakee4 from "../images/Killakee House/Aragon-Killakee_DSC9448-5 new2.jpg";
import killakee5 from "../images/Killakee House/Aragon-Killakee_DSC93982 new2.jpg";

const imagesHero = [
  {
    id: 1,
    name: "Killakee House",
    image: hero1,
  },
  {
    id: 2,
    name: "Dundrum House",
    image: hero2,
  },
];

//test before use contentful API

const testCarousel = [
  {
    name: "killakee1",
    img: killakee1,
  },
  {
    name: "killakee2",
    img: killakee2,
  },
  {
    name: "killakee3",
    img: killakee3,
  },
  {
    name: "killakee4",
    img: killakee4,
  },
  {
    name: "killakee5",
    img: killakee5,
  },
];

const testCarousel2 = [
  {
    name: "dundrum1",
    img: dundrum1,
  },
  {
    name: "dundrum2",
    img: dundrum2,
  },
  {
    name: "dundrum3",
    img: dundrum3,
  },
  {
    name: "dundrum4",
    img: dundrum4,
  },
  {
    name: "dundrum1",
    img: dundrum1,
  },
  {
    name: "dundrum5",
    img: dundrum5,
  },
  {
    name: "dundrum6",
    img: dundrum6,
  },
  {
    name: "dundrum7",
    img: dundrum7,
  },
  {
    name: "dundrum8",
    img: dundrum8,
  },
];

export { imagesHero, testCarousel, testCarousel2 };
